// extracted by mini-css-extract-plugin
module.exports = {"app":"App__app___NghkZ","container":"App__container___1h1fz","loader":"App__loader___1cVgu"};